import { Button } from "@fieldwork/ui/components/button";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";

/** Shown instead of the router's raw crash screen. Logs the full error for debugging. */
export default function AppError({ error: raw, reset }: ErrorComponentProps) {
  const error = raw as Error | undefined;
  useEffect(() => {
    console.error("fieldwork page error:", raw);
  }, [raw]);
  const stale = /dynamically imported module|Importing a module script failed|is not a function|Failed to fetch/i.test(
    String(error?.message ?? ""),
  );
  return (
    <div className="mx-auto mt-16 grid w-full max-w-lg gap-3 px-4 text-sm">
      <h1 className="text-lg font-semibold">This page hit an error</h1>
      <p className="text-muted-foreground">
        {stale
          ? "The panel was probably updated while this tab was open. Reloading gets the new version."
          : "Reloading usually fixes it. If it keeps happening, send a screenshot of this box."}
      </p>
      <pre className="overflow-auto bg-muted p-3 text-[11px]">{String(error?.stack ?? error?.message ?? raw).slice(0, 1200)}</pre>
      <div className="flex gap-2">
        <Button onClick={() => window.location.reload()}>Reload</Button>
        <Button variant="outline" onClick={() => reset()}>
          Try again
        </Button>
      </div>
    </div>
  );
}
